/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsRename } from "../funcs/agentsRename.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ManagedAgent } from "../models/components/managedagent.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RenameAgentRequest,
  RenameAgentSecurity,
} from "../models/operations/renameagent.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RenameAgentMutationVariables = {
  request: RenameAgentRequest;
  security?: RenameAgentSecurity | undefined;
  options?: RequestOptions;
};

export type RenameAgentMutationData = ManagedAgent;

export type RenameAgentMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * rename agents
 */
export function useRenameAgentMutation(
  options?: MutationHookOptions<
    RenameAgentMutationData,
    RenameAgentMutationError,
    RenameAgentMutationVariables
  >,
): UseMutationResult<
  RenameAgentMutationData,
  RenameAgentMutationError,
  RenameAgentMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRenameAgentMutation(client, options),
    ...options,
  });
}

export function mutationKeyRenameAgent(): MutationKey {
  return ["@gram/client", "agents", "rename"];
}

export function buildRenameAgentMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RenameAgentMutationVariables,
  ) => Promise<RenameAgentMutationData>;
} {
  return {
    mutationKey: mutationKeyRenameAgent(),
    mutationFn: function renameAgentMutationFn({
      request,
      security,
      options,
    }): Promise<RenameAgentMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsRename(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
